import axios from '../axiosConfig';

export default {

  getAdminPurchaseOrderList: (paramsPayload) => axios.get('/api/orion/adminPurchaseOrders', {
    params: paramsPayload
  }).then(response => response.data),

  getPurchaseOrderList: (paramsPayload) => axios.get('/api/orion/purchaseOrders', {
    params: paramsPayload
  }).then(response => response.data),

  getPurchaseOrderById: (orderId, orderType) => axios.get('/api/orion/purchaseOrderById', {
    params: {
      orderId,
      orderType
    }
  }).then(response => response.data),

  getDeliveryVouchersByPurchaseOrder: (purchaseOrderId, orderType) => axios.get(`/api/ocot/getDeliveryVouchersByPurchaseOrder`, { params: { purchaseOrderId, orderType } })
    .then(response => response.data),

  addDeliveryVoucherToPurchaseOrder: request => axios.post('/api/ocot/addDeliveryVoucherToPurchaseOrder', request)
    .then(response => response.data),

  deleteDeliveryVoucherById: deliveryVoucherId => axios.get(`/api/ocot/deleteDeliveryVoucherById`, { params: { deliveryVoucherId } })
    .then(response => response.data),

  getInvoiceFilesByPurchaseOrder: (purchaseOrderId, orderType) => axios.get(`/api/ocot/getInvoiceFilesByPurchaseOrder`, { params: { purchaseOrderId, orderType } })
    .then(response => response.data),

  addInvoiceFileToPurchaseOrder: request => axios.post('/api/ocot/addInvoiceFileToPurchaseOrder', request)
    .then(response => response.data),

  deleteInvoiceFileById: invoiceFileId => axios.get(`/api/ocot/deleteInvoiceFileById`, { params: { invoiceFileId } })
    .then(response => response.data),

  getAssociatedInvoicesByPurchaseOrder: (purchaseOrderId, orderType) => axios.get(`/api/ocot/invoicesByPurchaseOrder`, { params: { purchaseOrderId, orderType } })
    .then(response => response.data),

  getInvoiceByInvoiceNumberAndRut: (invoiceNumber, rut) => axios.get(`/api/ocot/invoiceByInvoiceNumberAndRut`, { params: { invoiceNumber, rut } })
    .then(response => response.data),

  getAssociatedInvoicesInfoByPurchaseOrder: (purchaseOrderId, type) => axios.get(`/api/ocot/invoicesInfoByPurchaseOrder`, { params: { purchaseOrderId, type } })
  .then(response => response.data),

  deleteAssociatedInvoiceById: invoiceId => axios.get(`/api/ocot/deleteInvoiceById`, { params: { invoiceId } })
    .then(response => response.data),

  associateManualInvoice: request => axios.post('/api/ocot/associateManualInvoice', request)
    .then(response => response.data),

  associateElectronicInvoices: request => axios.post('/api/ocot/associateElectronicInvoices', request)
    .then(response => response.data),

  requestPayment: request => axios.post('/api/ocot/requestInvoicesPayment', request)
    .then(response => response.data),

  requestAutomatedPayment: (idPeritation, policyNum, sinisterNum, sinisterDate, purchaseOrderId, orderType, providerCode, amount, date, invoices, file, rut, providerName, userCode, coin, formNumber) => axios.post('/api/ocot/requestAutomatedPayment', 
  { idPeritation, policyNum, sinisterNum, sinisterDate, purchaseOrderId, orderType, providerCode, amount, date, invoiceFile: { file }, invoices, rut, providerName, userCode, coin, formNumber })
    .then(response => response.data),

  changeInvoicesState: request => axios.post('/api/ocot/changeInvoicesState', request)
    .then(response => response.data),

  addPurchaseOrderDeleted: (purchaseOrderId, type) => axios.get(`/api/ocot/addPurchaseOrderDeleted`, { params: { purchaseOrderId, type} })
    .then(response => response.data),

  deletePurchaseOrderDeleted: (purchaseOrderId, type) => axios.get(`/api/ocot/deletePurchaseOrderDeleted`, { params: { purchaseOrderId, type} })
    .then(response => response.data),

  addPurchaseOrders: (idPeritation, policyNum, sinisterNum, sinisterDate, purchaseOrderId, orderType, providerCode, amount, date) => axios.post(`/api/ocot/addPurchaseOrders`, 
  {
    peritaciones: [
      {idPeritacion: idPeritation, nroPoliza: policyNum, nroSiniestro: sinisterNum,fechaSiniestro: sinisterDate,
      ordenes: [{ idCompra: purchaseOrderId,tipo: orderType,codProveedor: providerCode,monto: amount,fecha: date}] }]
  })
    .then(response => response.data),

};
